import { Component, SimpleChanges, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { MemberService } from './../../../../../../rest/api/member.service';
import { AuthService } from './../../../../../../services/auth.service';
import { HelperService } from './../../../../../../services/helper.service';

@Component({
  selector: 'app-space-setting',
  templateUrl: './space-setting.component.html',
  styleUrls: ['./space-setting.component.scss']
})
export class SpaceSettingComponent implements OnInit, OnChanges {
  @Input() spaceData;
  @Output() changeSpaceConfigEmit = new EventEmitter();
  @Output() closeMenuEmit = new EventEmitter();

  show: boolean;
  // show1: boolean;
  text: string;
  accessToken: any;

  spaceConfig = {
    show_drag: 1,
    auto_rotate: 1,
    show_control_buttons: 1,
    show_tour_button: 1,
    highlight_reel_count: null
  };

  highlightReelConfigData = [];

  constructor(
    public memberService: MemberService,
    public authService: AuthService,
    public helperService: HelperService,
  ) {
    this.show = true;
    this.text = 'close';
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.initHighlightReelConfigData();
   }

  initHighlightReelConfigData() {
    let i;
    for (i = 1; i <= 10; i ++) {
      this.highlightReelConfigData.push(i);
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.spaceData && changes.spaceData.currentValue) {
      this.spaceConfig.show_drag = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.show_drag ?
      changes.spaceData.currentValue.config.show_drag : false;
      this.spaceConfig.auto_rotate = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.auto_rotate ?
      changes.spaceData.currentValue.config.auto_rotate : false;
      this.spaceConfig.show_control_buttons = changes.spaceData.currentValue.config &&
      changes.spaceData.currentValue.config.show_control_buttons ? changes.spaceData.currentValue.config.show_control_buttons : false;
      this.spaceConfig.show_tour_button = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.show_tour_button ?
      changes.spaceData.currentValue.config.show_tour_button : false;
      this.spaceConfig.highlight_reel_count = changes.spaceData.currentValue.config && changes.spaceData.currentValue.config.highlight_reel_count ?
      changes.spaceData.currentValue.config.highlight_reel_count : null;
    }
  }

  changeSpaceConfig() {
    let formData;
    formData = this.spaceConfig;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateSpaceConfig({
      Authorization: this.accessToken,
      id: this.spaceData.config.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.updateSpaceConfig(response && response.data ? response.data : undefined, 'config');
      this.changeSpaceConfigEmit.emit(response && response.data ? response.data : undefined);
    }, err => {
      this.updateSpaceConfig(this.spaceData, 'space');
    });
  }

  updateSpaceConfig(configData, type) {
    if (type === 'config') {
      this.spaceConfig.show_drag = configData.show_drag ? configData.show_drag : false;
      this.spaceConfig.auto_rotate = configData.auto_rotate  ? configData.auto_rotate : false;
      this.spaceConfig.show_control_buttons = configData.show_control_buttons  ? configData.show_control_buttons : false;
      this.spaceConfig.show_tour_button = configData.show_tour_button  ? configData.show_tour_button : false;
      this.spaceConfig.highlight_reel_count = configData.highlight_reel_count  ? configData.highlight_reel_count : null;
    } else {
      this.spaceConfig.show_drag = configData.config.show_drag ? configData.config.show_drag : false;
      this.spaceConfig.auto_rotate = configData.config.auto_rotate  ? configData.config.auto_rotate : false;
      this.spaceConfig.show_control_buttons = configData.config.show_control_buttons  ? configData.config.show_control_buttons : false;
      this.spaceConfig.show_tour_button = configData.config.show_tour_button  ? configData.config.show_tour_button : false;
      this.spaceConfig.highlight_reel_count = configData.config.highlight_reel_count  ? configData.config.highlight_reel_count : null;
    }
  }

  closeMenu() {
    this.closeMenuEmit.emit(true);
  }

}
